module.exports = __webpack_public_path__ + "static/media/MoreVertical.70fb3718.svg";